import React, { useMemo, useState } from 'react';
import { Box, CompassColor, Text, useBreakpointValue } from '@noom/wax-component-library';
export function Interest({ data, onClick, isSelected, isDisabled }) {
    const handleClick = () => {
        if (!isDisabled) {
            onClick === null || onClick === void 0 ? void 0 : onClick(data);
        }
    };
    const flex = useBreakpointValue({ base: 1, sm: 0 });
    return (React.createElement(Box, { onClick: handleClick, bg: CompassColor.offWhite, borderRadius: "full", paddingX: 4, paddingY: 2, fontSize: "sm", cursor: "pointer", textAlign: "center", whiteSpace: "nowrap", flex: flex, boxSizing: "border-box", boxShadow: isSelected ? 'outline' : 'none', userSelect: "none" },
        React.createElement(Text, { mr: 2 }, data.emoji),
        " ",
        React.createElement(Text, null, data.description)));
}
function InterestsContainer({ children }) {
    return (React.createElement(Box, { display: "flex", flexDir: "row", flexWrap: "wrap", gap: 2, paddingX: 1 }, children));
}
export function InterestSelect({ interests, isDisabled, onChange }) {
    const sortedInterests = useMemo(() => [...interests].sort((a, b) => a.description.localeCompare(b.description)), [interests]);
    const [selected, setSelected] = useState([]);
    const onToggle = (data) => {
        if (isDisabled) {
            return;
        }
        let updatedArray = [];
        if (selected.find((i) => i.name === data.name)) {
            updatedArray = selected.filter((i) => i.name !== data.name);
        }
        else {
            updatedArray = [...selected, data];
        }
        setSelected(updatedArray);
        onChange === null || onChange === void 0 ? void 0 : onChange(updatedArray);
    };
    return (React.createElement(InterestsContainer, null, sortedInterests.map((interest) => (React.createElement(Interest, { key: interest.name, data: interest, isDisabled: isDisabled, isSelected: selected.some((i) => i.name === interest.name), onClick: onToggle })))));
}
//# sourceMappingURL=InterestSelect.js.map